import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import SvgIcon from './SvgIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var AvgIcon = function AvgIcon(props) {
  return /*#__PURE__*/_jsxs(SvgIcon, _objectSpread(_objectSpread({}, props), {}, {
    width: "25px",
    height: "25px",
    viewBox: "0 0 18.0 18.0",
    children: [/*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsx("clipPath", {
        id: "i0",
        children: /*#__PURE__*/_jsx("path", {
          d: "M1,0 L1,6 L0,6 L0,1 C-6.28042769e-17,0.487164161 0.38604019,0.0644928393 0.883378875,0.00672773133 L1,0 Z"
        })
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "i1",
        children: /*#__PURE__*/_jsx("path", {
          d: "M3,0 C3.51283584,-9.42064153e-17 3.93550716,0.38604019 3.99327227,0.883378875 L4,1 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 L3,0 Z"
        })
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "i2",
        children: /*#__PURE__*/_jsx("path", {
          d: "M4,0 L4,1 L0,1 L0,0 L4,0 Z"
        })
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "i3",
        children: /*#__PURE__*/_jsx("path", {
          d: "M0,0 C0.55228475,-1.01453063e-16 1,0.44771525 1,1 L1,6 L0,6 L0,0 Z"
        })
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "i4",
        children: /*#__PURE__*/_jsx("path", {
          d: "M1,0 L1,4.5 L0,4.5 L0,0 L1,0 Z"
        })
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "i5",
        children: /*#__PURE__*/_jsx("path", {
          d: "M1,0 L1,2.12132034 L0,2.12132034 L0,0 L1,0 Z"
        })
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "i6",
        children: /*#__PURE__*/_jsx("path", {
          d: "M1,0 L1,2.12132034 L0,2.12132034 L0,0 L1,0 Z"
        })
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "i7",
        children: /*#__PURE__*/_jsx("path", {
          d: "M1,0 L1,1 L0,1 L0,0 L1,0 Z"
        })
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "i8",
        children: /*#__PURE__*/_jsx("path", {
          d: "M1,0 L1,6 C0.44771525,6 6.76353751e-17,5.55228475 0,5 L0,1 C-6.28042769e-17,0.487164161 0.38604019,0.0644928393 0.883378875,0.00672773133 L1,0 Z"
        })
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "i9",
        children: /*#__PURE__*/_jsx("path", {
          d: "M4,0 C4,0.55228475 3.55228475,1 3,1 L1,1 C0.44771525,1 6.76353751e-17,0.55228475 0,0 L4,0 Z"
        })
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "i10",
        children: /*#__PURE__*/_jsx("path", {
          d: "M2,0 L2,1 L0,1 L0,0 L2,0 Z"
        })
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "i11",
        children: /*#__PURE__*/_jsx("path", {
          d: "M1,0 L1,2 C1,2.51283584 0.61395981,2.93550716 0.116621125,2.99327227 L0,3 L0,0 L1,0 Z"
        })
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "i12",
        children: /*#__PURE__*/_jsx("path", {
          d: "M0,0 C0.55228475,-1.01453063e-16 1,0.44771525 1,1 L1,2 L0,2 L0,0 Z"
        })
      })]
    }), /*#__PURE__*/_jsxs("g", {
      transform: "translate(2.0 6.0)",
      children: [/*#__PURE__*/_jsx("g", {
        clipPath: "url(#i0)",
        children: /*#__PURE__*/_jsx("polygon", {
          points: "0,0 1,0 1,6 0,6 0,0",
          stroke: "none",
          fill: "#000000"
        })
      }), /*#__PURE__*/_jsx("g", {
        clipPath: "url(#i1)",
        children: /*#__PURE__*/_jsx("polygon", {
          points: "0,0 4,0 4,1 0,1 0,0",
          stroke: "none",
          fill: "#000000"
        })
      }), /*#__PURE__*/_jsx("g", {
        transform: "translate(0.0 3.0)",
        children: /*#__PURE__*/_jsx("g", {
          clipPath: "url(#i2)",
          children: /*#__PURE__*/_jsx("polygon", {
            points: "0,0 4,0 4,1 0,1 0,0",
            stroke: "none",
            fill: "#000000"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        transform: "translate(3.0 0.0)",
        children: /*#__PURE__*/_jsx("g", {
          clipPath: "url(#i3)",
          children: /*#__PURE__*/_jsx("polygon", {
            points: "0,0 1,0 1,6 0,6 0,0",
            stroke: "none",
            fill: "#000000"
          })
        })
      })]
    }), /*#__PURE__*/_jsx("g", {
      transform: "translate(7.0 6.0)",
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#i4)",
        children: /*#__PURE__*/_jsx("polygon", {
          points: "0,0 1,0 1,4.5 0,4.5 0,0",
          stroke: "none",
          fill: "#000000"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      transform: "translate(6.999999999997901 10.500000000001082) rotate(-44.99999999999999)",
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#i5)",
        children: /*#__PURE__*/_jsx("polygon", {
          points: "-2.84217094e-14,0 1,0 1,2.12132034 -2.84217094e-14,2.12132034 -2.84217094e-14,0",
          stroke: "none",
          fill: "#000000"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      transform: "translate(10.292893218813573 9.7928932188128) rotate(45.00000000000001)",
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#i6)",
        children: /*#__PURE__*/_jsx("polygon", {
          points: "-2.84217094e-14,2.84217094e-14 1,2.84217094e-14 1,2.12132034 -2.84217094e-14,2.12132034 -2.84217094e-14,2.84217094e-14",
          stroke: "none",
          fill: "#000000"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      transform: "translate(12.0 6.0)",
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#i1)",
        children: /*#__PURE__*/_jsx("polygon", {
          points: "0,0 4,0 4,1 0,1 0,0",
          stroke: "none",
          fill: "#000000"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      transform: "translate(8.5 11.0)",
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#i7)",
        children: /*#__PURE__*/_jsx("polygon", {
          points: "0,0 1,0 1,1 0,1 0,0",
          stroke: "none",
          fill: "#000000"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      transform: "translate(10.0 6.0)",
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#i4)",
        children: /*#__PURE__*/_jsx("polygon", {
          points: "0,0 1,0 1,4.5 0,4.5 0,0",
          stroke: "none",
          fill: "#000000"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      transform: "translate(12.0 6.0)",
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#i8)",
        children: /*#__PURE__*/_jsx("polygon", {
          points: "0,0 1,0 1,6 0,6 0,0",
          stroke: "none",
          fill: "#000000"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      transform: "translate(12.0 11.0)",
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#i9)",
        children: /*#__PURE__*/_jsx("polygon", {
          points: "0,0 4,0 4,1 0,1 0,0",
          stroke: "none",
          fill: "#000000"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      transform: "translate(14.0 9.0)",
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#i10)",
        children: /*#__PURE__*/_jsx("polygon", {
          points: "0,0 2,0 2,1 0,1 0,0",
          stroke: "none",
          fill: "#000000"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      transform: "translate(15.0 9.0)",
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#i11)",
        children: /*#__PURE__*/_jsx("polygon", {
          points: "0,0 1,0 1,3 0,3 0,0",
          stroke: "none",
          fill: "#000000"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      transform: "translate(15.0 6.0)",
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#i12)",
        children: /*#__PURE__*/_jsx("polygon", {
          points: "0,0 1,0 1,2 0,2 0,0",
          stroke: "none",
          fill: "#000000"
        })
      })
    })]
  }));
};
export default AvgIcon;